<div class="gung-container" *ngIf="loginRequired || (!isLoading && !errorOccured && !denyAccess); else checkAccess">
  @if(!loginRequired){
    <car-liner-navbar></car-liner-navbar>
  }

  <div class="main" [ngStyle]="mainStyle">
    <router-outlet></router-outlet>
    <div class="mockroles-warning">
      <lib-mockroles-warning></lib-mockroles-warning>
    </div>

    <lib-gung-notification></lib-gung-notification>
    <car-liner-pdf-download-indicator></car-liner-pdf-download-indicator>
    <lib-pdf-download-indicator></lib-pdf-download-indicator>

    <div *ngIf="cookiesEnabled">
      <lib-gung-cookie-consent></lib-gung-cookie-consent>
    </div>
  </div>

  @if(!loginRequired){
    <ng-template [libCustomHostDynamic]="footerComponent" [inputs]="{}" [outputs]="{}" />
  }
</div>
<ng-template #noApp>
  <div class="wrapper d-flex align-items-center justify-content-center m-5">
    <div *ngIf="isLoading && !errorOccured">
      <i class="fa fa-spinner fa-spin fa-7x"></i>
    </div>
    <div *ngIf="errorOccured">
      <h1 class="text-center">An error occured, please log out and contact your supplier</h1>
      <div class="d-flex justify-content-center">
        <button class="btn btn-primary" (click)="logout()" translate>LOGOUT</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #checkAccess>
  <div *ngIf="denyAccess; else noApp">
    <div class="wrapper d-flex flex-column align-items-center justify-content-center m-5" style="min-height: 60vh;">
      <div class="card p-4 shadow" style="max-width: 400px; width: 100%;">
        <h6 class="text-center mb-4" translate>ACCESS_DENIED</h6>

        <div *ngFor="let domain of suggestedRedirectDomains" class="mb-2 d-block">
          <a [href]="domain" class="btn btn-outline-primary btn-block">
            {{ domain }}
          </a>
        </div>

        <button class="btn btn-primary btn-block mt-3" (click)="logout()" translate>LOGOUT</button>
      </div>
    </div>
  </div>
</ng-template>
